import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { Claim } from 'src/app/shared/models/cases/claim';
import { ClaimType } from 'src/app/shared/models/cases/claimType';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';
import { ClaimTypeCreateEditComponent } from 'src/app/shared/settings/claim-type-create-edit/claim-type-create-edit.component';

@Component({
  selector: 'app-create-new-claim',
  templateUrl: './create-new-claim.component.html',
  styleUrls: ['./create-new-claim.component.scss']
})
export class CreateNewClaimComponent implements OnInit {
  claim: Claim;
  claimAmount = 0;
  claimType = null;
  claimCurrency = null;
  claimTypeNgSelect = null;
  modalRef: NgbModalRef;
  public currencies;


  @Output('submitClaim') submitClaim: EventEmitter<Claim> = new EventEmitter();

  @ViewChild('claimTypeModal') claimTypeModal: ClaimTypeCreateEditComponent;
  @ViewChild('claimModal') claimModal;

  constructor(
    private filesApi: FilesApiService,
    private toastr: ToastrService,
    private modalService: NgbModal,

  ) { }

  ngOnInit(): void {
    this.currencies = require('currencies.json').currencies;
    this.claimTypeNgSelect = new NgSelectProps(this.filesApi.getClaimTypes);

  }
  open(claim: Claim) {
    this.claim = Object.assign(new Claim(), claim);
    this.modalRef = this.modalService.open(this.claimModal, {
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  addClaimFn = (claim) => this.addItemFn(new ClaimType(), claim, this.claimTypeModal, 'claimType', 'claimTypeAr');

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

  claimTypeSubmit(claimType: ClaimType) {
    this.claimType = claimType;
    this.claimTypeModal.close();
    this.toastr.success('Claim Type added', 'Success!');
  }

  onSubmit() {
    this.submitClaim.emit(this.claim);
    this.modalRef.close();
  }

  searchFn() {
    return true;
  }


}
